import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex } from "../../models";
import { successfulLogin } from "../../auth/authDataSlice";
import { DividendFilter } from "./types";
import moment from "moment";

type DividendPageState = {
	index: PageIndex;
	filter: DividendFilter;
};

export const initialState: DividendPageState = {
	index: {
		itemsPerPage: 20,
		pageNumber: 0,
	},
	filter: {
	//	datefrom: moment().add(-180, "day").toString()
	},
};

const name = "dividends";

const dividendsSlice = createSlice({
	name,
	initialState,
	reducers: {
		setDividendsIndex: (state, action: PayloadAction<PageIndex>) => ({
			...state,
			index: action.payload,
		}),
		resetDividendsIdices: state => ({
			...state,
			index: {
				itemsPerPage: state.index.itemsPerPage,
				pageNumber: initialState.index.pageNumber,
			},
		}),
		setFilter: (state, action: PayloadAction<DividendFilter>) => ({
			...state,
			filter: action.payload,
		}),
		removeFilter: (state, action: PayloadAction<keyof DividendFilter>) => ({
			...state,
			filter: {
				...state.filter,
				[action.payload]: undefined,
			},
		}),
	},
	extraReducers: builder => {
		builder.addCase(successfulLogin, state => ({
			...state,
			index: {
				itemsPerPage: state.index.itemsPerPage,
				pageNumber: initialState.index.pageNumber,
			},
		}));
	},
});

export const { setDividendsIndex, resetDividendsIdices, setFilter, removeFilter } = dividendsSlice.actions;

export default dividendsSlice.reducer;
